import { render, staticRenderFns } from "./next.vue?vue&type=template&id=15e3c845&scoped=true&"
import script from "./next.vue?vue&type=script&lang=js&"
export * from "./next.vue?vue&type=script&lang=js&"
import style0 from "./next.vue?vue&type=style&index=0&id=15e3c845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e3c845",
  null
  
)

export default component.exports